<div class="feedback-dialog-wrapper">
  <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()" data-test-id="feedback-modal-form">
    <h1 mat-dialog-title>
      Send feedback
      <button
        [disabled]="sending"
        (click)="closeDialog()"
        class="close-btn"
        data-test-id="feedback-modal-close-button"
        isIconButton="true"
        mat-button
        type="button"
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </h1>
    <div aria-label="Feedback dialog" class="feedback-dialog" mat-dialog-content>
      <p>Share an idea or report a problem</p>
      <div class="ng-select-flex-content-wrapper filter-feedback-type">
        <ng-select
          [closeOnSelect]="true"
          [items]="categories"
          bindLabel="name"
          bindValue="value"
          data-test-id="feedback-modal-feedback-type"
          formControlName="feedbackType"
          id="feedbackType"
          placeholder="Feedback type"
        ></ng-select>
        <label class="ng-select-label" for="feedbackType">Feedback type</label>
        <validation-messages
          [field]="feedbackForm.controls.feedbackType"
          [messages]="['required']"
          [texts]="{ required: 'Please select a feedback type.' }"
          data-test-id="feedback-modal-feedback-type-validationMessage"
        ></validation-messages>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>Your message</mat-label>
        <textarea
          data-test-id="feedback-modal-form-message-textarea"
          formControlName="feedbackContent"
          matInput
          rows="4"
        ></textarea>

        <mat-error
          [field]="feedbackForm.controls.feedbackContent"
          [messages]="['required', 'maxlength']"
          [texts]="{
            required: 'Please enter your message.',
            maxlength: 'Message cannot exceed ' + VALIDATORS.ContentMaxLength + ' characters.',
          }"
          data-test-id="feedback-modal-form-message-textarea-validationMessage"
        ></mat-error>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button
        [disabled]="sending"
        [loading]="sending"
        class="small-button"
        color="accent"
        data-test-id="feedback-modal-form-send-button"
        mat-flat-button
        type="submit"
      >
        Send feedback
      </button>
      <button
        [disabled]="sending"
        (click)="closeDialog()"
        class="small-button"
        color="accent"
        data-test-id="feedback-modal-form-cancel-button"
        mat-button
        type="button"
      >
        Cancel
      </button>
    </div>
  </form>
</div>
